export default "__VITE_ASSET__mGvRHZjV__"